import { withInstall } from '@hd-front-end/utils'
import Teleport from './src/teleport.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElTeleport: SFCWithInstall<typeof Teleport> = withInstall(Teleport)

export default ElTeleport

export * from './src/teleport'
